/**
 * Device Detection Utility
 * Detects if user is on mobile or desktop device
 */

export const isMobileDevice = () => {
  // Check if we're in a browser environment
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  // Check userAgent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Mobile patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
    /Mobile/i,
  ];

  const isMobileUA = mobilePatterns.some((pattern) => pattern.test(userAgent));

  // Also check touch support and screen width as additional signals
  const hasTouchSupport =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const hasSmallScreen = window.innerWidth <= 768;

  // Consider it mobile if either:
  // 1. UserAgent indicates mobile, OR
  // 2. Has touch support AND small screen (tablet/phone)
  return isMobileUA || (hasTouchSupport && hasSmallScreen);
};

/**
 * Get device type string
 */
export const getDeviceType = () => {
  return isMobileDevice() ? "mobile" : "desktop";
};
